/**
 *  Site mutations module file
**/

import { MUTATIONS } from './constants'

export const mutations = {
  [MUTATIONS.SET_CONFIG] (state, config) {
    state.config = config
  },
  [MUTATIONS.SET_BACK_LINK] (state, payload) {
    state.backLink = payload
  },
  [MUTATIONS.SAVE_BILLING_NOTIFICATION] (state, payload) {
    state.billingNotification = payload
  }
}
